import { useEffect, useRef } from "react";

import { useKeyboardControls } from "@react-three/drei";
import { GoGear, GoUnmute } from "react-icons/go";
import { addEffect } from "@react-three/fiber";

import useGame from "@stores/useGame";

export function Interface() {
    const forward = useKeyboardControls((state) => state.forward);
    const backward = useKeyboardControls((state) => state.backward);
    const leftward = useKeyboardControls((state) => state.leftward);
    const rightward = useKeyboardControls((state) => state.rightward);
    const jump = useKeyboardControls((state) => state.jump);

    const restart = useGame((state) => state.restart);
    const phase = useGame((state) => state.phase);

    const [subscribeKeys] = useKeyboardControls();

    const timeRef = useRef();

    useEffect(() => {
        const destroy = addEffect(() => {
            const state = useGame.getState();
            let elapsedTime = 0;

            if (state.phase === "ready") {
                elapsedTime = 0;
            } else if (state.phase === "playing") {
                elapsedTime = Date.now() - state.startTime;
            } else if (state.phase === "ended") {
                elapsedTime = state.endTime - state.startTime;
            }

            elapsedTime /= 1000;
            elapsedTime = elapsedTime.toFixed(2);

            if (timeRef.current) {
                timeRef.current.textContent = elapsedTime;
            }
        })

        return () => destroy()
    }, []);

    useEffect(() => {
        const destroy = subscribeKeys(
            (state) => state.reset,
            (value) => {
                if (value) restart();

            }
        )

        return () => destroy()
    }, [])

    return (
        <div className="interface">
            <div className="header">
                <div className="container">
                    <div className=""></div>

                    <div ref={timeRef} className="time">
                        0.00
                    </div>

                    <div className="items">
                        <div className="audio" style={{ opacity: 0 }}>
                            <GoUnmute color="white" size={21} />
                        </div>
                        <div className="configuration"  style={{ opacity: 0 }}>
                            <GoGear color="white" size={21} />
                        </div>
                    </div>
                </div>
            </div>

            {
                phase === "ended" && <div className="restart" onClick={restart}>Restart</div>
            }

            <div className="controls">
                <div className="raw">
                    <div className={`key ${forward ? 'active' : ''}`}></div>
                </div>
                <div className="raw">
                    <div className={`key ${leftward ? 'active' : ''}`}></div>
                    <div className={`key ${backward ? 'active' : ''}`}></div>
                    <div className={`key ${rightward ? 'active' : ''}`}></div>
                </div>
                <div className="raw">
                    <div className={`key large ${jump ? 'active' : ''}`}></div>
                </div>
            </div>

            <div className="commands">
                <button className="reset">
                    R - Reset
                </button>
            </div>
        </div>
    )
}